import request from "@/utils/request";
import { IProductsQuery } from "@/props/IProduct";

/**
 * 获取站点信息
 * @param {*} params
 * @returns
 */
export function getSiteInfoApi() {
  return request({
    url: "/front/site-info",
    method: "GET",
  });
}

/**
 * 语言列表按 showCNLanguages 缓存：
 * 首页同时挂了桌面(<Locale>)与移动(<MobileDefaultHeader>)两个 <Languages> 实例，
 * 各自会请求一遍。语言列表在会话内不变，故按参数做「在途去重 + 结果缓存」，
 * 无论挂多少实例都只发一次请求。
 */
const languagesCache: Record<string, Promise<any>> = {};

/**
 * 获取站点信息
 * @param {*} params
 * @returns
 */
export function getLanguagesApi(params: { showCNLanguages?: string }) {
  const key = params.showCNLanguages ?? "";
  if (!languagesCache[key]) {
    languagesCache[key] = request({
      url: "/front/languages/list",
      method: "GET",
      params,
    }).catch((err) => {
      // 失败不缓存，下次调用可重试
      delete languagesCache[key];
      throw err;
    });
  }
  return languagesCache[key];
}

// module.exports.getLanguagesApi = (params: { showCNLanguages?: string }) => {
//   return request({
//     url: "/front/languages/list",
//     method: "GET",
//     params,
//   });
// };
